import {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilState} from 'recoil';
import {baseUrlTypeState, userInfoState} from './Atoms';

const TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

/**
 * 세션 타임아웃 훅
 * 30분 동안 사용자 활동이 없으면 자동 로그아웃
 */
export const useSessionTimeout = () => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const [, setBaseUrlType] = useRecoilState(baseUrlTypeState);
  const navigate = useNavigate();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!userInfo?.accessToken) return;

    const doLogout = () => {
      localStorage.clear();
      sessionStorage.clear();
      setUserInfo(null);
      setBaseUrlType('dev');
      navigate('/', {replace: true});
    };

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(doLogout, TIMEOUT_MS);
    };

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [userInfo?.accessToken]);
};
